module.exports = __webpack_public_path__ + "img/stock5.9f3e768a.png";